interface SentryGate {
  /** True under the vite dev server, false for any `vite build`. */
  isDevServer: boolean;
  /** Explicit opt-in, to verify Sentry itself from a dev server. */
  devOptIn: boolean;
}

/**
 * A dev server loads the same `.env.<mode>` as the deployed build of that mode,
 * and only its error events are localhost-filtered — so without this it spends
 * the deployed logs and spans budget.
 */
export const shouldInitSentry = ({
  isDevServer,
  devOptIn,
}: SentryGate): boolean => !isDevServer || devOptIn;
